import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c38949bc")

_pushScopeId("data-v-c38949bc")
const _hoisted_1 = { class: "item hover-effect" }
const _hoisted_2 = { class: "user-email" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "ID: ", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("個人設定")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("ログアウト")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")

  return (_ctx.userEmail)
    ? (_openBlock(), _createBlock(_component_el_dropdown, {
        key: 0,
        style: {"height":"100%"},
        trigger: "hover",
        "show-timeout": 100
      }, {
        dropdown: _withId(() => [
          _createVNode(_component_el_dropdown_menu, { placement: "bottom" }, {
            default: _withId(() => [
              _createVNode("p", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(_toDisplayString(_ctx.userEmail), 1)
              ]),
              _createVNode(_component_el_dropdown_item, {
                divided: "",
                icon: "el-icon-user",
                onClick: _ctx.handleGotoProfile
              }, {
                default: _withId(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_dropdown_item, {
                icon: "el-icon-switch-button",
                onClick: _ctx.handleLogout
              }, {
                default: _withId(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_el_avatar, {
              icon: "el-icon-s-custom ",
              size: "large"
            })
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
})